
import { ReactNode } from "react";
import { Box, darken } from "@mui/material";

interface MarkerProps {
	color: string,
	icon?: ReactNode;
	label?: string | ReactNode;
	showLabelOnHover?: boolean;
	onClick?: () => void;
	content?: ReactNode;
}

const Marker = ({
	color,
	icon,
	label,
	showLabelOnHover = false,
	onClick,
	content,
}: MarkerProps) => {
	return (
		<Box
			onClick={() => onClick?.()}
			sx={{
				alignItems: "center",
				backgroundColor: color,
				border: `2px solid ${darken(color, 0.3)}`,
				borderRadius: "30px",
				cursor: onClick ? "pointer" : "auto",
				display: "flex",
				justifyContent: "center",
				position: "relative",
				height: 30,
				left: -15,
				top: -37,
				width: 30,

				"--label-display": showLabelOnHover ? "none" : "inherit",

				"&:hover": {
					"--label-display": "block",
				},
			}}>
			{icon && (
				<Box
					sx={{
						"> svg": {
							color: "#fff",
							fontSize: 14,
						},
					}}>
					{icon}
				</Box>
			)}

			{content && (
				<Box
					sx={{
						alignItems: "center",
						borderRadius: "30px",
						display: "flex",
						color: "#FFF",
						fontSize: 13,
						fontWeight: 600,
						height: 26,
						justifyContent: "center",
						width: 26,
					}}>
					{content}
				</Box>
			)}

			<Box
				sx={{
					backgroundColor: darken(color, 0.3),
					borderRadius: "50% 50% 50% 0",
					height: 28,
					left: -1,
					position: "absolute",
					top: 0,
					transform: "rotate(-45deg)",
					width: 28,
					zIndex: -1,
				}} />

			{label && (
				<MarkerLabel label={label} />
			)}
		</Box>
	);
};

export const MarkerLabel = ({ label }: { label: string | ReactNode }) => {
	return (
		<Box
			sx={{
				backgroundColor: "rgb(0, 0, 0, 0.6)",
				color: "#fff",
				display: "var(--label-display)",
				fontWeight: 600,
				left: 40,
				lineHeight: "19px",
				maxWidth: 170,
				overflow: "hidden",
				pl: 1,
				pr: 1,
				position: "absolute",
				textOverflow: "ellipsis",
				top: "50%",
				transform: "translateY(-50%)",
				whiteSpace: "nowrap",
				zIndex: 50,
			}}>
			{label}
		</Box>
	);
};

export default Marker;
